import { useTranslations } from '@vocab/react';
import { Alert, Notice, Strong, Text } from 'braid-design-system';

import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetYearsOfExperienceDocument } from 'src/types/graphql';

import translations from './.vocab';

export const ReadYearsOfExperience = ({
  emptyCardText,
}: {
  emptyCardText: string;
}) => {
  const { t } = useTranslations(translations);
  const { language } = useAppConfig();
  const { data, loading, error } = useQuery(GetYearsOfExperienceDocument, {
    variables: { languageCode: language },
  });

  const yearsOfExperience =
    loading || error ? null : data?.viewer?.yearsOfExperience;

  const { newToWorkforce, option } = yearsOfExperience ?? {};
  const id = option?.id;

  if (newToWorkforce) {
    return (
      <Alert tone="info">
        <Text>
          {t(
            'Are you still new to the workforce? If not, please update your total years of experience to add a new role.',
            { Strong: (v) => <Strong>{v}</Strong> },
          )}
        </Text>
      </Alert>
    );
  }

  return id ? (
    <Text tone="secondary" data={{ automation: `career-history-empty-nudge` }}>
      {emptyCardText}
    </Text>
  ) : (
    <Notice tone="info">
      <Text>
        {t('Please update your total years of experience to add a new role.')}
      </Text>
    </Notice>
  );
};
